import React from "react";
import { ToastContainer } from "react-toastify";
import Header from "../Header";
import ScrollToTop from "../ScrollToTop";
import { useSelector } from "react-redux";
import FloatingWhatsapp from "../FloatingWhatsapp";
import { PageBackground, PageContainer } from "../../styles/Container";
import RodapeIdentidadeVisual from "../RodapeIdentidadeVisual";

const MainLayoutCompact = ({ children, history }) => {
  const { telefone_whatsapp, exibir_whatsapp, link_para_contato } = useSelector((state) =>
    state.store.data == null ? "" : state.store.data.empresa
  );

  return (
    <>
      <ScrollToTop />
      <ToastContainer autoClose={2500} />
      <Header history={history} />
      <PageBackground>
        <PageContainer>{children}</PageContainer>
      </PageBackground>
      <RodapeIdentidadeVisual />
      {exibir_whatsapp && (telefone_whatsapp || link_para_contato) && <FloatingWhatsapp contactLink={link_para_contato} whatsappPhoneNumber={telefone_whatsapp ? `55${telefone_whatsapp.replace(/\D/g, '')}` : undefined} />}
    </>
  );
}

export default MainLayoutCompact;
